import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../../constants";
import { useUi, cx } from "../../ui";
import { fmtShort } from "../data";

/* ---------- Search + status pills + active day chip ---------- */

const useStyles = makeStyles({
  bar: { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 },
  search: { width: 320, maxWidth: "100%" },
  pill: {
    borderRadius: 999,
    padding: "6px 14px",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "background .15s ease, border-color .15s ease, color .15s ease",
  },
  dayChip: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: 999,
    background: T.accent,
    color: T.accentFg,
    padding: "6px 12px",
    fontSize: 12,
    fontWeight: 600,
  },
  dayClear: {
    marginLeft: 8,
    border: "none",
    background: "transparent",
    color: T.mutedFg,
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: 12,
  },
});

export default function BookingFilters({
  query,
  onQuery,
  statusFilter,
  onStatusFilter,
  awaitingCount,
  dayFilter,
  onClearDay,
  pills,
  placeholder = "Search by booking, ticket, plate, guest or email...",
}) {
  const s = useStyles();
  const ui = useUi();

  const filterPills = pills || [
    { id: "all", label: "All" },
    { id: "awaiting", label: `Awaiting (${awaitingCount})` },
    { id: "prepaid", label: "Pre-paid" },
    { id: "allocated", label: "Allocated" },
    { id: "redeemed", label: "Redeemed" },
    { id: "flagged", label: "Flagged" },
  ];

  return (
    <div className={s.bar}>
      <input
        value={query}
        onChange={(e) => onQuery(e.target.value)}
        placeholder={placeholder}
        className={cx(ui.field, s.search)}
      />
      {filterPills.map((p) => {
        const active = statusFilter === p.id;
        return (
          <button
            key={p.id}
            onClick={() => onStatusFilter(p.id)}
            className={s.pill}
            style={{
              border: `1px solid ${active ? T.primary : T.border}`,
              background: active ? T.primary : T.elevated,
              color: active ? T.primaryFg : T.mutedFg,
            }}
          >
            {p.label}
          </button>
        );
      })}
      {dayFilter && (
        <span className={s.dayChip}>
          Day: {fmtShort(dayFilter)}
          <button onClick={onClearDay} className={s.dayClear}>
            x
          </button>
        </span>
      )}
    </div>
  );
}
